// extracted by mini-css-extract-plugin
export var wrapper = "text-module--wrapper--1BLd-";
export var straight = "text-module--straight--h0VgW";
export var classic = "text-module--classic--2H2nm";
export var show = "text-module--show--3SrY1";
export var textContainer75 = "text-module--text-container-75--3Qt4Y";
export var quoteSign = "text-module--quoteSign--1k5q-";